import { useState } from "react";
import { http } from "@/lib/api";
import { toast } from "sonner";
import { FileSpreadsheet, FileText, Loader2 } from "lucide-react";

export default function ExportButtons({ kind, params = {}, testId = "export" }) {
  const [busy, setBusy] = useState("");

  const run = async (format) => {
    setBusy(format);
    try {
      const res = await http.get(`/export/${kind}`, {
        params: { format, ...params },
        responseType: "blob",
      });
      const url = URL.createObjectURL(res.data);
      const a = document.createElement("a");
      a.href = url;
      a.download = `laporan_${kind}.${format === "pdf" ? "pdf" : "xlsx"}`;
      a.click();
      URL.revokeObjectURL(url);
      toast.success(`Laporan ${format.toUpperCase()} berhasil diunduh`);
    } catch {
      toast.error("Gagal mengunduh laporan");
    } finally {
      setBusy("");
    }
  };

  return (
    <div className="flex gap-2">
      <button
        data-testid={`${testId}-excel-button`}
        onClick={() => run("xlsx")}
        disabled={!!busy}
        className="h-10 px-3 border border-neutral-800 text-xs uppercase tracking-wide flex items-center gap-2 hover:bg-neutral-900 hover:text-white transition-colors disabled:opacity-60"
      >
        {busy === "xlsx" ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : <FileSpreadsheet className="h-3.5 w-3.5" />}
        Excel
      </button>
      <button
        data-testid={`${testId}-pdf-button`}
        onClick={() => run("pdf")}
        disabled={!!busy}
        className="h-10 px-3 border border-[#FF3B30] text-[#b91c1c] text-xs uppercase tracking-wide flex items-center gap-2 hover:bg-[#FF3B30] hover:text-white transition-colors disabled:opacity-60"
      >
        {busy === "pdf" ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : <FileText className="h-3.5 w-3.5" />}
        PDF
      </button>
    </div>
  );
}
